import React from 'react';
const points = [{
  emoji: '😰',
  text: 'The anxiety of arriving at the rink without knowing exactly what tactical setup to run today.'
}, {
  emoji: '⏱️',
  text: "Wasting expensive ice-time trying to explain drills that weren't properly planned."
}, {
  emoji: '🤷',
  text: "Roster emergencies: Not knowing how to adapt when players don't show up at the last minute."
}, {
  emoji: '📊',
  text: 'No clear criteria: Struggling to track player development and tactical hockey IQ.'
}, {
  emoji: '😓',
  text: 'Bored players who end up just "scrimmaging" because there\'s no professional plan.'
}, {
  emoji: '😩',
  text: 'Ruined Sundays spent drawing drills on old notebooks instead of resting.'
}];
export function ForWhomSection() {
  return <section className="w-full bg-bg-dark py-16 sm:py-24 px-4" data-id="element-99">
      <div className="max-w-3xl mx-auto" data-id="element-100">
        <div className="text-center mb-12" data-id="element-101">
          <h2 className="text-3xl sm:text-5xl font-serif font-black text-text-main mb-4" data-id="element-102">
            👉 Do you recognize yourself in these situations?
          </h2>
          <p className="text-text-sec text-base sm:text-lg" data-id="element-103">
            If you answer "yes" to any of these, this pack is for you:
          </p>
        </div>

        <div className="space-y-4 mb-12" data-id="element-104">
          {points.map((point, i) => <div key={i} className="flex items-center gap-4 sm:gap-6 bg-bg-alt rounded-2xl p-5 sm:p-6 border border-border-light shadow-sm" data-id="element-105">
              <div className="text-3xl sm:text-4xl flex-shrink-0" data-id="element-106">
                {point.emoji}
              </div>
              <p className="text-text-main font-medium text-base sm:text-lg leading-snug" data-id="element-107">
                {point.text}
              </p>
            </div>)}
        </div>

        <div className="text-center" data-id="element-108">
          <p className="text-primary font-serif italic text-xl sm:text-2xl font-bold" data-id="element-109">
            You deserve more… and that’s where ICE HOCKEY READY comes in. →
          </p>
        </div>
      </div>
    </section>;
}